import { Component, Injector, OnInit } from '@angular/core';
import { IPageHeader } from '@modeso/aumico-lib-core-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';
import { PersonsProvider } from '../../../../../../aumico-lib-companies-fe/src/lib';
import { Paths } from '../../../enums/paths.enum';
import { RouteLabels } from '../../../enums/routeLabels.enum';
import { BasePageComponent } from '../../../pages/base.page';

/**
 * REV-22155 — detail page of a person, like `CompanyDetailsPage`: header with back arrow + name
 * ("Brunner Laura") and the tabs "Projekte" / "Profil". Loads the person; the tab
 * pages read it from the store.
 */
@UntilDestroy()
@Component({
    selector: 'app-person-details-page',
    template: `<app-aumico-layout hideFooter="true">
        <ng-container header>
            <ham-page-header [title]="pageHeader.value" [backButtonRoute]="['../overview']"></ham-page-header>
            <ham-page-tab-navigation [navigationItems]="navigationTabs"></ham-page-tab-navigation>
        </ng-container>
        <ng-container content>
            <router-outlet></router-outlet>
        </ng-container>
    </app-aumico-layout>`,
})
export class PersonDetailsPage extends BasePageComponent implements OnInit {
    pageHeader: IPageHeader = {
        isLocalizedKey: false,
        value: '',
    };

    readonly navigationTabs: { routerLink: string; tabLabelKey: string }[] = [
        { routerLink: Paths.PROJECT, tabLabelKey: RouteLabels.PROJECT_LIST },
        { routerLink: Paths.PROFILE, tabLabelKey: RouteLabels.PERSON_PROFILE },
    ];

    constructor(injector: Injector, private readonly personsProvider: PersonsProvider) {
        super(injector);
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.personsProvider
            .getSelectedPerson$()
            .pipe(
                filter((person) => person != null),
                untilDestroyed(this),
            )
            .subscribe((person) => {
                // "Nachname Vorname", as in the overview.
                this.pageHeader = { isLocalizedKey: false, value: `${person.lastName} ${person.firstName}` };
            });

        this.personsProvider.dispatchPersonById(this.activatedRoute.snapshot.params['personId']);
    }
}
